/**
 * Color Configuration
 * Reads theme colors from environment variables (.env.development)
 * Falls back to default values if env variables are not set
 */

const defaultColors = {
  primary: '#0f538d',
  secondary: '#ffa726',
  black: '#282828',
  grey: '#969696',
  mediumGrey: '#cdcdcd',
  lightGrey: '#F9FAFC',
  red: '#ff1717',
  green: '#2fab73',
  blue: '#0323c7',
  yellow: '#ffe84a',
  violet: '#6665DD',
  white: '#ffffff',
  lightBlue: '#EDFBF9',
  skyBlue: '#EFEEFD',
  lightPink: '#FFF1D2',
  lightOrange: '#ffa72633',
  darkRed: '#BE0909',
  lightGreen: '#34D19E',
  lightBlack: '#414D55',
};

const colorConfig = {
  primary: process.env.REACT_APP_PRIMARY_COLOR || defaultColors.primary,
  secondary: process.env.REACT_APP_SECONDARY_COLOR || defaultColors.secondary,
  black: process.env.REACT_APP_BLACK_COLOR || defaultColors.black,
  grey: process.env.REACT_APP_GREY_COLOR || defaultColors.grey,
  mediumGrey: process.env.REACT_APP_MEDIUM_GREY_COLOR || defaultColors.mediumGrey,
  lightGrey: process.env.REACT_APP_LIGHT_GREY_COLOR || defaultColors.lightGrey,
  red: process.env.REACT_APP_RED_COLOR || defaultColors.red,
  green: process.env.REACT_APP_GREEN_COLOR || defaultColors.green,
  blue: process.env.REACT_APP_BLUE_COLOR || defaultColors.blue,
  yellow: process.env.REACT_APP_YELLOW_COLOR || defaultColors.yellow,
  violet: process.env.REACT_APP_VIOLET_COLOR || defaultColors.violet,
  white: process.env.REACT_APP_WHITE_COLOR || defaultColors.white,
  lightBlue: process.env.REACT_APP_LIGHT_BLUE_COLOR || defaultColors.lightBlue,
  skyBlue: process.env.REACT_APP_SKY_BLUE_COLOR || defaultColors.skyBlue,
  lightPink: process.env.REACT_APP_LIGHT_PINK_COLOR || defaultColors.lightPink,
  lightOrange: process.env.REACT_APP_LIGHT_ORANGE_COLOR || defaultColors.lightOrange,
  darkRed: process.env.REACT_APP_DARK_RED_COLOR || defaultColors.darkRed,
  lightGreen: process.env.REACT_APP_LIGHT_GREEN_COLOR || defaultColors.lightGreen,
  lightBlack: process.env.REACT_APP_LIGHT_BLACK_COLOR || defaultColors.lightBlack,
};

export default colorConfig;
